import { useCallback } from 'react';

import type { ActionTemplate } from 'config/api/actionLibrary/actionLibrary.types';
import isPocketSafeActionTemplateStaff from 'helpers/isPocketSafeActionTemplateStaff';
import userDataStorage from 'storages/userDataStorage';

const useCanEditActionTemplate = () => {
  // @ts-ignore
  const userData = userDataStorage.get() || {};
  const { ps_roles = [] } = userData;
  const isPocketSafeTemplateStaffUser = isPocketSafeActionTemplateStaff(ps_roles);

  const canEdit = useCallback(
    (template: ActionTemplate) => {
      if (!template) return false;

      // PocketSafe Content Editor or Action Template Library Administrator: any template
      if (isPocketSafeTemplateStaffUser) return true;

      if (template.ownerType === 'pocketsafe') return false;

      return true;
    },
    [isPocketSafeTemplateStaffUser],
  );

  return canEdit;
};

export default useCanEditActionTemplate;
